import { ChangeEvent, useState } from "react";
import { ReactComponent as Plus } from 'assets/common/filePlus.svg'
import { ReactComponent as FileIcon } from 'assets/common/file.svg'
import { ReactComponent as DelIcon } from 'assets/common/fileDel.svg'
import { toast } from "react-toastify";

interface DragDropProps {
    onChangeFile: (file: File | null) => void;
    description?: string;
}

const DragFile = ({
    onChangeFile,
    description = "파일 첨부",
}: DragDropProps) => {

    // 사용자가 파일을 드래드 중임을 상태로 관리 UI 변경을 위해 사용
    const [dragOver, setDragOver] = useState<boolean>(false);
    const [data, setData] = useState<File | null>();
    const MEGABYTES = 15;
    const MAX_FILE_SIZE = MEGABYTES * 1024 * 1024;

    // 드래그 중인 요소가 목표 지점 진입할때
    const handleDragEnter = (e: React.DragEvent<HTMLLabelElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setDragOver(true);
    };

    // 드래그 중인 요소가 목표 지점을 벗어날때
    const handleDragLeave = (e: React.DragEvent<HTMLLabelElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setDragOver(false);
    };

    // 드래그 중인 요소가 목표 지점에 위치할때
    const handleDragOver = (e: React.DragEvent<HTMLLabelElement>) => {
        e.preventDefault();
        e.stopPropagation();
    };

    // 드래그 중인 요소가 목표 지점에서 드롭될때
    const handleDrop = (e: React.DragEvent<HTMLLabelElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setDragOver(false);

        // 드래그되는 데이터 정보와 메서드를 제공하는 dataTransfer 객체 사용
        if (e.dataTransfer) {
            const file = e.dataTransfer.files[0];
            if (file.type.includes('pdf')) {
                if (file && file?.size > MAX_FILE_SIZE) {
                    return toast.error(`${MEGABYTES}MB이하 사이즈만 가능합니다.`)
                }
                onChangeFile(file);
                setData(file)
            }
            else {
                toast.error('PDF파일만 업로드 가능합니다.')
            }
        }
    };

    // Drag & Drop이 아닌 클릭 이벤트로 업로드되는 기능도 추가
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files ? e.target.files[0] : null;
        if (file && file?.size > MAX_FILE_SIZE) {
            return toast.error(`${MEGABYTES}MB이하 사이즈만 가능합니다.`)
        }
        onChangeFile(file);
        setData(file)

        // input 요소의 값 초기화
        e.target.value = "";
    };

    const delFile = () => {
        onChangeFile(null);
        setData(null)
    }
    return (
        <div className="mb-1 w-full">
            <label
                className={`flex flex-col items-center justify-center border-2 border-dashed gap-3 h-35 rounded cursor-pointer
                    bg-[#F8F8FA] text-xs
                    ${dragOver
                        ? "border-primary text-primary"
                        : "border-[#9D9EB7] text-[#A8A9BF]"
                    }`}
                htmlFor="fileUpload"
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
            >
                {
                    data ?
                        <div className="relative flex flex-col justify-center items-center gap-2 w-full h-full">
                            <FileIcon />
                            <DelIcon onClick={(e) => {
                                e.preventDefault()
                                delFile()
                            }} className="top-4 right-4 absolute" />
                            <p className="text-black">{data.name}</p>
                        </div> :
                        <>
                            <Plus />
                            <p className="text-center" dangerouslySetInnerHTML={{ __html: description }}></p>
                        </>
                }


            </label>
            <input
                id="fileUpload"
                type="file"
                className="hidden"
                onChange={handleChange}
                accept=".pdf"
            ></input>
        </div>
    );
};


export default DragFile;